import * as React from 'react';

import { PaywallScreens } from '~analytics/types';
import { PaywallDispatch } from '~teacher/components/PaywallDialog';

interface UseImportQuizDialogParams {
  paywallDispatch: PaywallDispatch;
  currentQuizCount: number;
  quizLimit: number;
}

export function useImportQuizToPersonalDialog({
  paywallDispatch,
  currentQuizCount,
  quizLimit,
}: UseImportQuizDialogParams) {
  const [isImportQuizDialogOpen, setIsImportQuizDialogOpen] =
    React.useState(false);
  const onCloseImportQuizDialog = () => setIsImportQuizDialogOpen(false);
  const onOpenImportQuizDialog = () => {
    if (currentQuizCount >= quizLimit) {
      paywallDispatch({
        type: 'OPEN',
        touch: [
          PaywallScreens.QuizListLimitReached,
          PaywallScreens.QuizListAddQuiz,
        ],
      });
      return;
    }
    setIsImportQuizDialogOpen(true);
  };
  return {
    isImportQuizDialogOpen,
    onCloseImportQuizDialog,
    openImportQuizDialog: onOpenImportQuizDialog,
  };
}
